import { t } from 'i18next'

import { FormGroup, Input, Label, Select } from '~/components/unform'

import { getRegionData } from './lib'

const RegionField = ({
  isRequired,
  loading,
  country,
  name = 'region',
  maxLength = 4
}: RegionFieldProps) => {
  const placeholder = t('c:components.AddressFieldset.placeholders.state')

  const regionData = getRegionData(country)

  const formatOptions = (items: RegionDataItem[]) =>
    items.map(item => ({
      id: item.code,
      value: item.code,
      text: item.name
    }))

  return (
    <FormGroup>
      <Label isRequired={isRequired} htmlFor={name}>
        {t('c:components.AddressFieldset.labels.state')}
      </Label>

      {regionData ? (
        <Select
          name={name}
          options={formatOptions(regionData.items)}
          placeholder={placeholder}
          disabled={loading}
          required={isRequired}
        />
      ) : (
        <Input
          name={name}
          placeholder={placeholder}
          loading={loading}
          disabled={loading}
          required={isRequired}
          maxLength={maxLength}
        />
      )}
    </FormGroup>
  )
}

export default RegionField
